export const API_KEY = {
    POST:`v1/subscription`,
    PUT:`v1/subscription`,
    REGISTER:`v1/account/register`,
    GET_MODULE:`v1/module/getmodule`,
    GET_SCHEMA:'v1/Account/GetSchemaList',
    GET_DB_CONNECTION:`v1/account/getdbconnection`,
    Check_If_DB_Exist:`v1/account/CheckIfDBExist`,
    CHECK_ORGANIZATION_EXISTANCE : `v1/organization/IsOrganizationExists`,
}